import React from 'react';
import { GiftIcon } from 'lucide-react';
import { volumes } from '../data/volumes';
import { bonuses } from '../data/bonuses';
export function WhatYouGet() {
  return <section id="volumes" aria-labelledby="volumes-heading" className="bg-navy-950" data-id="element-204" data-mp="zy98von9jpgs">
      <div className="mx-auto max-w-content px-4 py-20 sm:px-6 lg:py-28" style={{
      paddingTop: "0px",
      paddingBottom: "0px"
    }} data-id="element-205" data-mp="l5fs7zw993aj">
        <div className="max-w-3xl" data-id="element-206" data-mp="1drh19ij64ozj">
          
          <h2 id="volumes-heading" className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-[2.75rem]" style={{
          paddingTop: "12px",
          paddingBottom: "12px",
          marginTop: "15px",
          marginBottom: "15px"
        }} data-id="element-207" data-mp="1dssdm6qoj529">
            Exactly What You Get Inside The Argentine Mindset System
          </h2>
          <p className="mt-4 text-lg text-white/70" data-id="element-208" data-mp="1wqux660gk9so">
            6 Complete Volumes + 5 Exclusive Bonuses + Lifetime Access.
          </p>
        </div>

        <ol className="mt-8 divide-y divide-white/10 border-y border-white/10" data-id="element-209" data-mp="21icyiv6e8ce6">
          {volumes.map(volume => <li key={volume.number} className="grid grid-cols-[3.25rem_1fr] items-center gap-x-4 gap-y-2 py-4 sm:grid-cols-[3.75rem_1fr] sm:gap-x-5 lg:grid-cols-[3.75rem_15rem_1fr]" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-210" data-mp="2vgc19fs6y7xu">
              <img src={volume.cover} alt={`Cover of Tomo ${volume.number}: ${volume.title}`} className="h-auto w-full rounded border border-white/15 object-cover shadow-[0_6px_18px_-10px_rgba(0,0,0,0.9)]" width={240} height={300} loading="lazy" decoding="async" data-id="element-211" data-mp="30edn28h04ld0" />
              <div data-id="element-212" data-mp="399l5z35725a1">
                <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-celeste-400" data-id="element-213" data-mp="3o47uubmgrjqe">
                  Tomo {volume.number}
                </p>
                <h3 className="mt-0.5 font-display text-base font-extrabold leading-tight tracking-tight text-white sm:text-lg" data-id="element-214" data-mp="3j66gg3zzg8l9">
                  {volume.title}
                </h3>
              </div>
              <p className="col-span-2 text-[13px] leading-snug text-white/70 lg:col-span-1" data-id="element-215" data-mp="1otgjfdebij9n">
                {volume.description}
              </p>
            </li>)}
        </ol>

        <div className="mt-10" data-id="element-216" data-mp="2ihmoaql3fv99">
          <div className="rounded-2xl border border-celeste-500/25 bg-navy-900 p-6 sm:p-8" style={{
          paddingTop: "0px",
          paddingBottom: "0px"
        }} data-id="element-217" data-mp="2iixq4kuzasxq">
            <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-sun" data-id="element-218" data-mp="2sgvbn0lgebmn">
              <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-219" data-mp="2xcap3rfju5ij" />
              Included free today
            </p>
            <h3 className="mt-2 font-display text-xl font-extrabold tracking-tight text-white sm:text-2xl" data-id="element-220" data-mp="366p37qocfa02">
              5 Exclusive Bonuses
            </h3>

            <ul className="mt-5 grid gap-4 sm:grid-cols-2" style={{
            paddingTop: "0px",
            paddingBottom: "0px"
          }} data-id="element-221" data-mp="3b5a47sbf5xpk">
              {bonuses.map(bonus => <li key={bonus.number} className="flex gap-3" data-id="element-222" data-mp="3l36e6gsmemm3">
                  <img src={bonus.cover} alt={`Cover of Bonus ${bonus.number}: ${bonus.name}`} className="h-16 w-16 shrink-0 rounded border border-white/15 object-cover" width={64} height={64} loading="lazy" decoding="async" data-id="element-223" data-mp="3l1lgiib0enk0" />
                  <div className="min-w-0" data-id="element-224" data-mp="zhwvyu1tqxsl">
                    <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-sun" data-id="element-225" data-mp="zior63rietic">
                      Bonus {bonus.number}
                    </p>
                    <h4 className="mt-0.5 font-display text-[15px] font-extrabold leading-tight tracking-tight text-white" data-id="element-226" data-mp="1s7dk3fievsj0">
                      {bonus.name}
                    </h4>
                    <p className="mt-1 text-[13px] leading-snug text-white/70" data-id="element-227" data-mp="1igsnfxmasy2q">
                      {bonus.description}
                    </p>
                    <p className="mt-0.5 text-[13px] text-celeste-300" data-id="element-228" data-mp="1dhocp2jq6saa">{bonus.detail}</p>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}